import { AppTextService } from '@fi-shared/app-text';
import {
    ChangeDetectionStrategy,
    Component,
    HostBinding,
    Input,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { IReportChartData } from '@fi-shared/fi-report-pie-chart/fi-report-pie-chart';
import { ITask2ReportSummary } from '../fi-task-v2-report';
import { IChartHistoryData } from '@fi-shared/fi-chart-history/fi-chart-history';

@Component({
    selector: 'fi-task-v2-report-chart',
    templateUrl: './fi-task-v2-report-chart.component.html',
    styleUrl: './fi-task-v2-report-chart.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-task-v2-report-chart' },
    standalone: false,
})
export class FiTaskV2ReportChartComponent implements OnChanges {
    @Input({ required: true }) summary: ITask2ReportSummary;
    @Input() isOnlyOverdue: boolean = false;
    @Input() chartHeading: string;
    @HostBinding('class.column-layout') @Input() isColumnLayout: boolean = false;

    constructor(private appTextService: AppTextService) {}

    private _reportChartData: ReadonlyArray<Readonly<IReportChartData>> = [];

    protected get reportChartData(): ReadonlyArray<Readonly<IReportChartData>> {
        return this._reportChartData;
    }

    private _historyItems: ReadonlyArray<Readonly<IChartHistoryData>> = [];

    protected get historyItems(): ReadonlyArray<Readonly<IChartHistoryData>> {
        return this._historyItems;
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['summary']) {
            this.updateChartData();
        }
    }

    private updateChartData(): void {
        const overdueHistoryItem = {
            indicatorClass: 'red',
            label: this.appTextService.get('task.overdue_plural'),
            value: this.summary?.OverdueCount || 0,
        };
        const overdueChartData: IReportChartData = {
            gradientColorLight: '#FF6454',
            gradientColorBright: '#DE3730',
            value: this.summary?.OverdueCount || 0,
        };
        if (this.isOnlyOverdue) {
            this._reportChartData = [overdueChartData];
            this._historyItems = [overdueHistoryItem];
            return;
        }
        this._reportChartData = [
            {
                gradientColorLight: '#99FFA3',
                gradientColorBright: '#13CA25',
                value: this.summary?.CompletedCount || 0,
            },
            {
                gradientColorLight: '#2196F3',
                gradientColorBright: '#0672C9',
                value: this.summary?.InProgressCount || 0,
            },
            {
                gradientColorLight: '#E5EFF5',
                gradientColorBright: '#C7C8C9',
                value: this.summary?.NotStartedCount || 0,
            },
            overdueChartData,
        ];
        this._historyItems = [
            {
                indicatorClass: 'green',
                label: this.appTextService.get('common.completed_plural'),
                value: this.summary?.CompletedCount || 0,
            },
            {
                indicatorClass: 'blue',
                label: this.appTextService.get('task.in_progress'), // SWE plural
                value: this.summary?.InProgressCount || 0,
            },
            {
                indicatorClass: 'grey',
                label: this.appTextService.get('checklist.not_started_yet'),
                value: this.summary?.NotStartedCount || 0,
            },
            overdueHistoryItem,
        ];
    }
}
